import { ApiError } from "./client";

export interface FileUploadOut {
  id: string;
  mime_type: string;
  size_bytes: number;
  url: string;
}

/**
 * Multipart upload uses fetch directly (apiRequest is JSON-only).
 * Returns the URL ready to use as <img src>.
 */
export async function uploadImage(file: File): Promise<FileUploadOut> {
  const fd = new FormData();
  fd.append("file", file);
  const response = await fetch("/api/academy/files", {
    method: "POST",
    credentials: "include",
    body: fd,
  });
  if (!response.ok) {
    let code: string | null = null;
    let detail: unknown = null;
    try {
      const j = await response.json();
      detail = j.detail ?? j;
      code = detail && typeof detail === "object" && "code" in detail
        ? String((detail as { code: unknown }).code)
        : null;
    } catch {
      /* not json */
    }
    throw new ApiError(
      response.status,
      code,
      detail,
      `Upload failed (${response.status})`,
    );
  }
  return (await response.json()) as FileUploadOut;
}

export function fileUrl(id: string): string {
  return `/api/academy/files/${id}`;
}
